export default __webpack_public_path__ + "static/media/goalkeeper-circle.01b21688.svg";